import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0c0fca0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_alert = _resolveComponent("a-alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      ref: "formLoginRef",
      model: _ctx.managerLoginRef,
      rules: _ctx.rules
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, { name: "email" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              class: "custom-input-style",
              placeholder: "Email",
              id: "email",
              value: _ctx.managerLoginRef.email,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.managerLoginRef.email) = $event))
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { name: "password" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              class: "custom-input-style",
              placeholder: "Password",
              id: "password",
              value: _ctx.managerLoginRef.password,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.managerLoginRef.password) = $event))
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_a_button, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.signin())),
                class: "login-btn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Sign in")
                ]),
                _: 1
              }),
              _createElementVNode("a", {
                class: "login-forgot-pass",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openForgotModal()))
              }, "Forgot password")
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.forgotModalVisible,
      "confirm-loading": _ctx.forgotModalLoading,
      title: "Forgot Password",
      onOk: _ctx.forgotPasswordHandle,
      onCancel: _ctx.forgotCancelHandle
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_input, {
          placeholder: "email",
          value: _ctx.forgotModalRef.email,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.forgotModalRef.email) = $event))
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible", "confirm-loading", "onOk", "onCancel"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.confirmModalVisible,
      "confirm-loading": _ctx.confirmModalLoading,
      title: "Confirm New Password",
      onOk: _ctx.confirmOkHandle,
      onCancel: _ctx.confirmCancelHandle,
      maskClosable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_alert, {
              message: "Check your email the confirmation code",
              type: "info",
              "show-icon": ""
            }),
            _hoisted_2,
            _createVNode(_component_a_form_item, { label: "code" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  class: "custom-input-style",
                  placeholder: "code",
                  id: "code",
                  name: "code",
                  autocomplete: "off",
                  value: _ctx.confirmModal.confirmationCode,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.confirmModal.confirmationCode) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "password" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  class: "custom-input-style",
                  placeholder: "password",
                  id: "confirmpass",
                  name: "confirmpass",
                  autocomplete: "off",
                  value: _ctx.confirmModal.password,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.confirmModal.password) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible", "confirm-loading", "onOk", "onCancel"])
  ], 64))
}